import { Image, Text3D, Center } from "@react-three/drei"
import { useRef } from "react"
import * as THREE from 'three';
import layout from "../dictionaries/layout";
import DiscordLogo from "../meshes/DiscordLogo";
import { trackEvent } from "../api";
import { useAtomValue } from "jotai";
import { languageAtom } from "../GlobalState";
import translations from "../dictionaries/translations";

export default function DiscordButton({ rotation, position, device='landscapeDesktop' }) {

  // in mobile, stretch it out
  // don't display room id

  const language = useAtomValue(languageAtom)
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"

  const discordTextMaterialRef = useRef()
  const discordBoxMaterialRef = useRef()
  function handleDiscordPointerEnter(e) {
    e.stopPropagation()
    discordTextMaterialRef.current.color = new THREE.Color('green')
    discordBoxMaterialRef.current.color = new THREE.Color('green')
    document.body.style.cursor = "pointer";
  }
  function handleDiscordPointerLeave(e) {
    e.stopPropagation()
    discordTextMaterialRef.current.color = new THREE.Color('yellow')
    discordBoxMaterialRef.current.color = new THREE.Color('yellow')
    document.body.style.cursor = "default";
  }
  async function handleDiscordPointerUp(e) {
    e.stopPropagation()
    
    // open discord link
    window.open('https://discord.gg/RwbTfezXu7', "_blank", "noreferrer");

    await trackEvent({ surface: 'end_scene', action: 'open_discord', category: 'ui' })
  }

  return <group name='discord-button' position={position} rotation={rotation}>
    <mesh>
      <boxGeometry args={layout[device].endSceneActionButtons.discordButton.outerBox.args}/>
      <meshStandardMaterial ref={discordBoxMaterialRef} color='yellow'/>
    </mesh>
    <mesh>
      <boxGeometry args={layout[device].endSceneActionButtons.discordButton.innerBox.args}/>
      <meshStandardMaterial color='black'/>
    </mesh>
    <mesh
      name='discord-button-wrapper'
      onPointerEnter={(e) => handleDiscordPointerEnter(e)}
      onPointerLeave={(e) => handleDiscordPointerLeave(e)}
      onPointerUp={(e) => handleDiscordPointerUp(e)}
    >
      <boxGeometry args={layout[device].endSceneActionButtons.discordButton.wrapper.args}/>
      <meshStandardMaterial color="grey" transparent opacity={0}/>
    </mesh>
    <Center position={[0, 0, layout[device].endSceneActionButtons.discordButton.text.position[2] || 0]}>
      <group>
        <Text3D
          font={fontUrl}
          size={layout[device].endSceneActionButtons.discordButton.text.fontSize}
          height={0.03} 
          position={[0, -0.21, 0]}
        >
          {translations.endScenes.discord[language]}
          <meshStandardMaterial ref={discordTextMaterialRef} color='yellow'/>
        </Text3D>
        <DiscordLogo 
          position={[
            translations.endScenes.discord[language].length * (layout[device].endSceneActionButtons.discordButton.text.fontSize * (language === 'korean' ? 1.2 : 0.8)) + 0.3,
            0,
            0
          ]}
          scale={layout[device].endSceneActionButtons.discordButton.logo.scale} 
          color='#545FD2'
        />
      </group>
    </Center>
  </group>
}